import { IMeta, IPagination, ISort } from "@delanobgt/admin-core/util/types";
import { produce } from "immer";
import { Reducer } from "redux";
import {
  EFloatingFundSortField,
  IFloatingFund,
  PFloatingFundFilter,
} from "src/core/floatingFund/entities";
import { ActionType, createAction, getType } from "typesafe-actions";

/*
 * state
 */
export interface IFloatingFundState {
  floatingFunds: IFloatingFund[];
  loading: boolean;
  error: any;
  meta: IMeta;
}

const initialState: IFloatingFundState = {
  floatingFunds: [],
  loading: false,
  error: null,
  meta: {
    limit: 10,
    offset: 0,
    total: 0,
  },
};

/*
 * action types
 */
const FETCH_REQUESTED = "floating-fund/FETCH_REQUESTED";
const FETCH_SUCCEEDED = "floating-fund/FETCH_SUCCEEDED";
const FETCH_FAILED = "floating-fund/FETCH_FAILED";
const POLLING_START_REQUESTED = "floating-fund/POLLING_START_REQUESTED";
const POLLING_STOP_REQUESTED = "floating-fund/POLLING_STOP_REQUESTED";

/*
 * action creators
 */
export const actions = {
  fetchRequested: createAction(FETCH_REQUESTED)(),

  fetchSucceeded: createAction(FETCH_SUCCEEDED)<{
    data: IFloatingFund[];
    meta: IMeta;
  }>(),

  fetchFailed: createAction(FETCH_FAILED)<any>(),

  pollingStartRequested: createAction(POLLING_START_REQUESTED)<{
    filter: PFloatingFundFilter;
    pagination: IPagination;
    sorts: ISort<EFloatingFundSortField>[];
    refreshDelay: number;
  }>(),

  pollingStopRequested: createAction(POLLING_STOP_REQUESTED)(),
};
export type TActions = ActionType<typeof actions>;

const reducer: Reducer<IFloatingFundState, TActions> = (
  state = initialState,
  action
) => {
  return produce<IFloatingFundState>(state, (draft) => {
    switch (action.type) {
      case getType(actions.fetchRequested): {
        draft.loading = true;
        draft.error = null;
        break;
      }
      case getType(actions.fetchSucceeded): {
        const {
          payload: { data, meta },
        } = action;
        draft.floatingFunds = data;
        draft.loading = false;
        draft.error = null;
        draft.meta = meta;
        break;
      }
      case getType(actions.fetchFailed): {
        const { payload } = action;
        draft.loading = false;
        draft.error = payload;
        break;
      }
    }
  });
};

export default reducer;
